import type { Prompt } from '../api/types'

/** Permissions put their short main line first and their literal detail
 * in a second paragraph. Other questions keep their original wording. */
export function permissionText(prompt: Prompt): { title: string; detail: string | null } {
  const split = prompt.choices_only ? prompt.text.indexOf('\n\n') : -1
  return split < 0 ? { title: prompt.text, detail: null } : { title: prompt.text.slice(0, split), detail: prompt.text.slice(split + 2) }
}
